import { createFileRoute } from '@tanstack/react-router';
import UnderDevelopment from '@src/pages/UnderDevelopment';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/clients')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('clients.page_title', 'Clients') }],
  }),
  component: UnderDevelopment,
});
